import { shouldForwardProp } from '@/utils/style.utils';
import styled from '@emotion/styled';
import { color, COLOR_VARIANTS } from '@tajawal/ct-web-design-system';
import _min from 'lodash/min';

const getIconColor = (isDisabled: boolean, isOverLayArrow = false, isDark = false) => {
  if (isDark && isDisabled) {
    return color(COLOR_VARIANTS.OVERLAY);
  }
  if (isOverLayArrow || isDark) {
    return color(COLOR_VARIANTS.WHITE);
  }
  return isDisabled ? color(COLOR_VARIANTS.GAINSBORO) : color(COLOR_VARIANTS.AQUA100);
};

const computeLeft = ({ $index, $containerWidth, $contentWidth, $cardWidth }: any) => {
  if ($index <= 0 && $contentWidth <= $containerWidth) {
    return 0;
  }
  const left = $index * $cardWidth + $index * 16;
  const maximumLeft = $contentWidth - $containerWidth;
  return `-${_min([left, maximumLeft])}px`;
};

const Container = styled.div`
  display: flex;
  gap: 16px;
  width: 100%;
  flex-direction: column;
  position: relative;
`;

const Slider = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 16px;
  justify-self: flex-end;
`;

const ArrowButton = styled('div', { shouldForwardProp })<{
  $isDisabled?: boolean;
  $hasOverlayArrows?: boolean;
  $isDark?: boolean;
}>`
  border-radius: 50%;
  border: 1px solid ${({ $isDisabled, $isDark }) => getIconColor($isDisabled, false, $isDark)};
  border: ${({ $hasOverlayArrows, $isDark }) => ($hasOverlayArrows || $isDark) && 'none'};
  background-color: ${({ $hasOverlayArrows, $isDark }) =>
    ($hasOverlayArrows || $isDark) && color(COLOR_VARIANTS.OVERLAY)};
  width: 32px;
  height: 32px;
  display: flex;
  cursor: ${({ $isDisabled }) => ($isDisabled ? 'not-allowed' : 'pointer')};
  justify-content: center;
  user-select: none;

  ${({ $hasOverlayArrows, $isDisabled }) =>
    $hasOverlayArrows &&
    ` 
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      z-index: 1;
      display: ${$isDisabled && 'none'};
      &:first-of-type {
        left: 0;
      }
      &: last-of-type: {
        right: 0;
      }
    `}
  svg {
    color: ${({ $isDisabled, $hasOverlayArrows, $isDark }) => getIconColor($isDisabled, $hasOverlayArrows, $isDark)};
    stroke: ${({ $isDisabled, $hasOverlayArrows, $isDark }) => getIconColor($isDisabled, $hasOverlayArrows, $isDark)};
    stroke-width: 1;
  }
`;

const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const Content = styled.div<{ $containerWidth?: number; $index?: number; $cardWidth?: number; $contentWidth?: number }>`
  display: flex;
  left: ${computeLeft};
  position: relative;
  transition: left 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
`;

export default {
  Container,
  Slider,
  ArrowButton,
  Header,
  Content,
};
